import * as yup from "yup";

/* --------------------------- Validation schemas for New Client Form ---------------------------*/

export const NEW_CLIENT_FORM_VALIDATION_SCHEMA = yup.object().shape({
    // CPR6Digit: yup.string().length(6, "CPR6Digit must be exactly 4 digits").required("CPR6Digit is required"),
    // CPRLast4Digit: yup
    //     .string()
    //     .length(4, "CPRLast4Digit must be exactly 4 digits")
    //     .required("CPRLast4Digit is required"),
    email: yup
        .string()
        .email("Ugyldigt e-mailadresseformat") // Valid email format
        .required("Personlige oplysninger i e-mail påkrævet") // Required field
});

/* --------------------------- Validation schemas for New Patient Form ---------------------------*/

export const NEW_PATIENT_FORM_VALIDATION_SCHEMA = yup.object().shape({
    nameFirst: yup.string().required("Fornavn er påkrævet"),
    nameLast: yup.string().required("Efternavn er påkrævet"),
    address: yup.string().required("Adresse er påkrævet"),
    town: yup.string().required("By er påkrævet"),
    post: yup.string().required("Postnummer er påkrævet"),
    CPR6Digit: yup.string().required("CPR6Digit is required"),
    CPRLast4Digit: yup
        .number()
        .typeError("CPRLast4Digit must be a number")
        .min(1000, "CPRLast4Digit must be exactly 4 digits") // Minimum 4-digit number
        .max(9999, "CPRLast4Digit must be exactly 4 digits") // Maximum 4-digit number
        .required("CPRLast4Digit is required"),
    email: yup
        .string()
        .email("Ugyldigt e-mailadresseformat") // Valid email format
        .required("Personlige oplysninger i e-mail påkrævet") // Required field
});
